import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Dropdown} from "primereact/dropdown";
import {BlockUI} from "primereact/blockui";
import {Calendar} from "primereact/calendar";
import {addLocale} from "primereact/api";
import {InputMask} from "primereact/inputmask";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment/moment";

import HelpComponent from "../HelpComponent";
import _FM_FolioListComponent from "../_FM_folio/_FM_FolioListComponent";
import FormLocker from "../../util/FormLocker";

const _FM_CustomerFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  // const [CFormData, setCFormData] = useState({});
  // const [COptions, setCOptions] = useState({});
  // const [CFields, setCFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "customer/" + formData.id,
        newFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({});
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderCustomerList: Math.random(),
            rerenderFolioList: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "customer",
        formData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderCustomerList: Math.random(),
            rerenderFolioList: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  addLocale('default', {
    firstDayOfWeek: 1,
    dayNames: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')],
    dayNamesShort: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    dayNamesMin: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    monthNames: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    monthNamesShort: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    today: t('today'),
    clear: t('delete')
  });

  useEffect(() => {
    if (window.App.urlVars().customerId || props.customerId || id) {
      setLoading(true)
      // setCFormData({
      //   ...CFormData,
      //   customer: id
      // })
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "customer/" + (window.App.urlVars().customerId ?? props.customerId ?? id),
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  // useEffect(() => {
  //   if (formData._country_specifics && Object.keys(formData._country_specifics).length > 0) {
  //     let countryObjectName = "customer_" + Object.keys(formData._country_specifics)[0].toLowerCase() + "s";
  //     if (formData[countryObjectName][0]) {
  //       axios({
  //         method: 'get',
  //         url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "customer-"
  //           + Object.keys(formData._country_specifics)[0].toLowerCase() + "/" + formData[countryObjectName][0].id,
  //         params: {},
  //         headers: {
  //           'Authorization': 'Bearer ' + Cookies.get("userToken"),
  //           "Sys-name": Cookies.get("instanceId"),
  //           "Preferred-locale": Cookies.get("language")
  //         }
  //       })
  //         .then(response => {
  //           setCFormData(response.data.data);
  //         })
  //         .catch(error => {
  //           window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //         })
  //     }
  //     const transformedCountry = Object.keys(formData._country_specifics)[0]
  //       ? Object.keys(formData._country_specifics)[0].charAt(0).toUpperCase() + Object.keys(formData._country_specifics)[0].slice(1).toLowerCase() : "";
  //     axios({
  //       method: 'get',
  //       url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "info/Customer" + transformedCountry,
  //       params: {},
  //       headers: {
  //         'Authorization': 'Bearer ' + Cookies.get("userToken"),
  //         "Sys-name": Cookies.get("instanceId"),
  //         "Preferred-locale": Cookies.get("language")
  //       }
  //     })
  //       .then(response => {
  //         setCFields(response.data.editable_fields);
  //       })
  //       .catch(error => {
  //         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //       })
  //   }
  // }, [formData._country_specifics])
  //
  // useEffect(() => {
  //   CFields.map((field, index) => {
  //     if (field.type.includes("Enum")) {
  //       axios({
  //         method: 'get',
  //         url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/" + field.name.replaceAll('_', '-'),
  //         params: {},
  //         headers: {
  //           'Authorization': 'Bearer ' + Cookies.get("userToken"),
  //           "Sys-name": Cookies.get("instanceId"),
  //           "Preferred-locale": Cookies.get("language")
  //         }
  //       })
  //         .then(response => {
  //           setCOptions({
  //             ...COptions,
  //             [field.name]: Object.values(response.data.data).flat()
  //           })
  //         })
  //         .catch(error => {
  //
  //         })
  //     }
  //   })
  // }, [CFields])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i
        className="pi pi-exclamation-triangle blocked-ui-message-icon"
        aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('customer_form')}</h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
                      <span>
                        <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                      </span>
                  </Button>
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary close p-ml-2">
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="lastname" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="lastname"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('lastname')}</label>
                      <InputText id="lastname" {...input}
                                 onChange={(e) => {
                                   setFormData({...formData, lastname: e.target.value});
                                   setNewFormData({...newFormData, lastname: e.target.value});
                                 }}
                                 value={formData.lastname}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="firstname" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="firstname"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('firstname')}</label>
                      <InputText id="firstname" {...input}
                                 onChange={(e) => {
                                   setFormData({...formData, firstname: e.target.value});
                                   setNewFormData({...newFormData, firstname: e.target.value});
                                 }}
                                 value={formData.firstname}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="gender" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="gender"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('gender')}</label>
                      <Dropdown  id="gender" {...input} options={[
                        {label: t('male'), value: 'MALE'},
                        {label: t('female'), value: 'FEMALE'},
                        {label: t('other'), value: 'OTHER'}
                      ]}
                                onChange={(e) => {
                                  setFormData({...formData, gender: e.value});
                                  setNewFormData({...newFormData, gender: e.value});
                                }}
                                value={formData.gender} className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="birth_date" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="birth_date"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('birth_date')}</label>
                      <div className="p-inputgroup calendar-icon-only">
                        <InputMask id={"birth_date"}
                                   mask={t('9999-99-99')}
                                   value={formData.birth_date}
                                   onChange={(e) => {
                                     if (e.value.indexOf("_") === -1) {
                                       if (e.value === '') {
                                         e.value = null
                                       }
                                       if (!e.value) {
                                         setFormData({
                                           ...formData,
                                           birth_date: null
                                         });
                                         setNewFormData({
                                           ...newFormData,
                                           birth_date: null
                                         });
                                         return;
                                       }
                                       const formattedBirthDate = moment.utc(e.value).local().format(t('YYYY-MM-DD'));
                                       const parsedBirthDate = moment(formattedBirthDate, t('YYYY-MM-DD'), true);
                                       if (!parsedBirthDate.isValid()) {
                                         return;
                                       }
                                       const minAllowedBirthYear = moment().year() - 99;
                                       if (parsedBirthDate.year() < minAllowedBirthYear) {
                                         window.App.customToastShow('warn', t('warning'), t('birth_date_too_old_warning'));
                                         return;
                                       }
                                       setFormData({
                                         ...formData,
                                         birth_date: formattedBirthDate
                                       });
                                       setNewFormData({
                                         ...newFormData,
                                         birth_date: formattedBirthDate
                                       });
                                     }
                                   }}
                        />
                        <Calendar
                          value={formData.birth_date ? moment(formData.birth_date, 'YYYY-MM-DD').toDate() : null}
                          locale="default"
                          dateFormat={t('YY-MM-DD')}
                          showIcon
                          onChange={(e) => {
                            if (!e.value) {
                              setFormData({
                                ...formData,
                                birth_date: null
                              });
                              setNewFormData({
                                ...newFormData,
                                birth_date: null
                              });
                              return;
                            }
                            const formattedBirthDate = moment.utc(e.value).local().format(t('YYYY-MM-DD'));
                            const parsedBirthDate = moment(formattedBirthDate, t('YYYY-MM-DD'), true);
                            if (!parsedBirthDate.isValid()) {
                              return;
                            }
                            const minAllowedBirthYear = moment().year() - 99;
                            if (parsedBirthDate.year() < minAllowedBirthYear) {
                              window.App.customToastShow('warn', t('warning'), t('birth_date_too_old_warning'));
                              return;
                            }
                            setFormData({
                              ...formData,
                              birth_date: formattedBirthDate
                            });
                            setNewFormData({
                              ...newFormData,
                              birth_date: formattedBirthDate
                            });
                          }}/>
                      </div>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="birth_place" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="birth_place"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('birth_place')}</label>
                      <InputText id="birth_place" {...input}
                                 onChange={(e) => {
                                   setFormData({...formData, birth_place: e.target.value});
                                   setNewFormData({...newFormData, birth_place: e.target.value});
                                 }}
                                 value={formData.birth_place}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="company_name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="company_name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('company_name')}</label>
                      <InputText id="company_name" {...input}
                                 onChange={(e) => {
                                   setFormData({...formData, company_name: e.target.value});
                                   setNewFormData({...newFormData, company_name: e.target.value});
                                 }}
                                 value={formData.company_name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="citizenship" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="citizenship">{t('citizenship')}</label>
                      <InputText id="citizenship" {...input} value={formData.citizenship}/>
                    </div>
                  )}/>
                </div>
                <div className="p-col-12 p-lg-4">
                  <Field name="id_type" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="id_type"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>
                        {t('id_type')}
                      </label>
                      <span className="p-d-block">
                            <Dropdown  options={[
                              {
                                name: t('id_card'),
                                value: 'ID_CARD',
                              },
                              {
                                name: t('passport'),
                                value: 'PASSPORT',
                              },
                              {
                                name: t('driver_license'),
                                value: 'DRIVER_LICENSE',
                              },
                              {
                                name: t('other'),
                                value: 'OTHER',
                              }
                            ]}
                                      filter
                                      optionLabel="name"
                                      optionValue="value"
                                      id={"id_type"}
                                      emptyMessage={t('empty_message')}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          id_type: e.value
                                        })
                                      }}
                                      value={formData.id_type}
                            />
                          </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="id_number" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="id_number">{t('id_number')}</label>
                      <InputText id="id_number" {...input} value={formData.id_number}
                                 onChange={(e) => {
                                   setFormData({...formData, id_number: e.target.value});
                                   setNewFormData({...newFormData, id_number: e.target.value});
                                 }}
                      />
                    </div>
                  )}/>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-2"}>
                  <Field name="zip_code" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="zip_code">{t('zip_code')}</label>
                      <InputText id="zip_code" {...input} value={formData.zip_code}
                                 onChange={(e) => {
                                   setFormData({...formData, zip_code: e.target.value});
                                   setNewFormData({...newFormData, zip_code: e.target.value});
                                 }}
                      />
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="address" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="address">{t('address')}</label>
                      <InputText id="address" {...input} value={formData.address}
                                 onChange={(e) => {
                                   setFormData({...formData, address: e.target.value});
                                   setNewFormData({...newFormData, address: e.target.value});
                                 }}
                      />
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3"}>
                  <Field name="email" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="email">{t('email')}</label>
                      <InputText id="email" {...input} value={formData.email}
                                 onChange={(e) => {
                                   setFormData({...formData, email: e.target.value});
                                   setNewFormData({...newFormData, email: e.target.value});
                                 }}
                      />
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3"}>
                  <Field name="phone" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="phone">{t('phone')}</label>
                      <InputText id="phone" {...input} value={formData.phone}
                                 onChange={(e) => {
                                   setFormData({...formData, phone: e.target.value});
                                   setNewFormData({...newFormData, phone: e.target.value});
                                 }}
                      />
                    </div>
                  )}/>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-12"}>
                  <Field name="note" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="note">{t('note')}</label>
                      <InputText id="note" {...input} value={formData.note}
                                 onChange={(e) => {
                                   setFormData({...formData, note: e.target.value});
                                   setNewFormData({...newFormData, note: e.target.value});
                                 }}
                      />
                    </div>
                  )}/>
                </div>
              </div>
            </Panel>
          </form>
        )}/>
        {id &&
          <Panel className={"p-mt-3"}>
            <_FM_FolioListComponent customerId={id}/>
          </Panel>
        }
        {/*{CFields && CFields[0] &&*/}
        {/*  <Panel className={"p-mt-3"}>*/}
        {/*    <h3 className={"p-mt-0"}>*/}
        {/*      {Object.keys(formData._country_specifics)[0].toUpperCase()}*/}
        {/*    </h3>*/}
        {/*    <div className={"p-grid"}>*/}
        {/*      {CFields && CFields[0] &&*/}
        {/*        <>*/}
        {/*          {CFields.map((field, index) => {*/}
        {/*            if (field.type.includes("Text")) {*/}
        {/*              return (*/}
        {/*                <>*/}
        {/*                  <div className={"p-col-12 p-lg-6"}>*/}
        {/*                    <div className="p-field p-fluid">*/}
        {/*                      <label htmlFor={field.name}>{t(field.name)}</label>*/}
        {/*                      <span className="p-d-block">*/}
        {/*                              <InputText id={field.name}*/}
        {/*                                         disabled={!formData.id}*/}
        {/*                                         onChange={(e) => {*/}
        {/*                                           setCFormData({*/}
        {/*                                             ...CFormData,*/}
        {/*                                             [field.name]: e.target.value*/}
        {/*                                           })*/}
        {/*                                         }}*/}
        {/*                                         value={CFormData[field.name]}*/}
        {/*                              />*/}
        {/*                            </span>*/}
        {/*                    </div>*/}
        {/*                  </div>*/}
        {/*                </>*/}
        {/*              )*/}
        {/*            }*/}
        {/*            if (field.type.includes("Enum")) {*/}
        {/*              return (*/}
        {/*                <>*/}
        {/*                  <div className={"p-col-12 p-lg-6"}>*/}
        {/*                    <div className="p-field p-fluid">*/}
        {/*                      <label htmlFor={field.name}>{t(field.name)}</label>*/}
        {/*                      <span className="p-d-block">*/}
        {/*                              <Dropdown  options={COptions[field.name]}*/}
        {/*                                        filter*/}
        {/*                                        optionLabel="key"*/}
        {/*                                        optionValue="value"*/}
        {/*                                        id={field.name}*/}
        {/*                                        emptyMessage={t('empty_message')}*/}
        {/*                                        onChange={(e) => {*/}
        {/*                                          setCFormData({*/}
        {/*                                            ...CFormData,*/}
        {/*                                            [field.name]: e.value*/}
        {/*                                          })*/}
        {/*                                        }}*/}
        {/*                                        value={CFormData[field.name]}*/}
        {/*                              />*/}
        {/*                            </span>*/}
        {/*                    </div>*/}
        {/*                  </div>*/}
        {/*                </>*/}
        {/*              )*/}
        {/*            }*/}
        {/*          })}*/}
        {/*        </>*/}
        {/*      }*/}
        {/*    </div>*/}
        {/*    <div className={"p-grid"}>*/}
        {/*      <div className={"p-col p-text-right p-col-align-center"}>*/}
        {/*        <Button type="button" label={t('save')} icon={"pi pi-save"}*/}
        {/*                loading={loading}*/}
        {/*                disabled={!formData.id}*/}
        {/*                onClick={() => {*/}
        {/*                  setLoading(true)*/}
        {/*                  if (CFormData.id) {*/}
        {/*                    axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "customer-"*/}
        {/*                      + Object.keys(formData._country_specifics)[0].toLowerCase() + "/" + CFormData.id,*/}
        {/*                      CFormData,*/}
        {/*                      {*/}
        {/*                        params: {},*/}
        {/*                        headers: {*/}
        {/*                          'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
        {/*                          "Sys-name": Cookies.get("instanceId"),*/}
        {/*                          "Preferred-locale": Cookies.get("language")*/}
        {/*                        }*/}
        {/*                      })*/}
        {/*                      .then(response => {*/}
        {/*                        setCFormData(response.data.data);*/}
        {/*                        setLoading(false)*/}
        {/*                        window.App.toastShow('success', t('success'), response.data.message)*/}
        {/*                      })*/}
        {/*                      .catch(error => {*/}
        {/*                        setLoading(false)*/}
        {/*                        window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)*/}
        {/*                      })*/}
        {/*                  } else {*/}
        {/*                    axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "customer-"*/}
        {/*                      + Object.keys(formData._country_specifics)[0].toLowerCase(),*/}
        {/*                      CFormData,*/}
        {/*                      {*/}
        {/*                        params: {},*/}
        {/*                        headers: {*/}
        {/*                          'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
        {/*                          "Sys-name": Cookies.get("instanceId"),*/}
        {/*                          "Preferred-locale": Cookies.get("language")*/}
        {/*                        }*/}
        {/*                      })*/}
        {/*                      .then(response => {*/}
        {/*                        setCFormData(response.data.data);*/}
        {/*                        setLoading(false)*/}
        {/*                        window.App.toastShow('success', t('success'), response.data.message)*/}
        {/*                      })*/}
        {/*                      .catch(error => {*/}
        {/*                        setLoading(false)*/}
        {/*                        window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)*/}
        {/*                      })*/}
        {/*                  }*/}

        {/*                }}*/}
        {/*                className="p-button-success p-ml-2"/>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </Panel>*/}
        {/*}*/}
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_CustomerFormComponent);
